module.exports = __webpack_public_path__ + "static/img/icon-使馆假期／近两月@2x.10ccf5d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/order/icon-使馆假期／近两月@2x.png
// module id = H3sY
// module chunks = 4